export let translationCatalog = window.django && window.django.catalog ? window.django.catalog : {};

export function djangoGetText(msgid) {
    var value = translationCatalog[msgid];
    if (typeof value == "undefined") {
        return msgid;
    } else {
        return typeof value == "string" ? value : value[0];
    }
}

export function setTranslationsForRequest(dynamicTranslationCatalog) {
    translationCatalog = dynamicTranslationCatalog;
}

function pluralidx(n) {
    var v = n != 1;
    if (typeof v == "boolean") {
        return v ? 1 : 0;
    } else {
        return v;
    }
}

export function djangoNGetText(singular, plural, count) {
    var value = translationCatalog[singular];
    if (typeof value == "undefined") {
        return count == 1 ? singular : plural;
    } else {
        return value[pluralidx(count)];
    }
}
